import React from 'react';
import { ThemeProvider } from 'styled-components';
import { ApolloProvider } from '@apollo/client';
import { ToastProvider } from 'react-toast-notifications';
import { BrowserRouter } from 'react-router-dom';
import moment from 'moment';
import GlobalStyle from './GlobalStyle';
import App from './App';
import apolloClient from './apolloClient';
import { UserStoreProvider } from './stores/UserStore';
import { GeneralGlobalStoreProvider } from './stores/GeneralGlobalStore';
import { EventsOverviewFilterProvider } from './stores/EventsOverviewFilterStore';
import BackendStatusChecker from './BackendStatusChecker';
import theme from './theme';
import 'nprogress/nprogress.css';
import './customNprogressStyle.css';
import 'react-datepicker/dist/react-datepicker.css';
import VersionChecker from './VersionChecker';
require('moment/locale/de');
moment.locale('de');
moment.weekdays(true);

const AppWrapper = () => {
  return (
    <ToastProvider autoDismissTimeout={3000} placement='top-center'>
      <BackendStatusChecker>
        <VersionChecker>
          <ApolloProvider client={apolloClient}>
            <GeneralGlobalStoreProvider>
              <EventsOverviewFilterProvider>
                <UserStoreProvider>
                  <ThemeProvider theme={theme}>
                    <BrowserRouter>
                      <GlobalStyle whiteColor />
                      <App />
                    </BrowserRouter>
                  </ThemeProvider>
                </UserStoreProvider>
              </EventsOverviewFilterProvider>
            </GeneralGlobalStoreProvider>
          </ApolloProvider>
        </VersionChecker>
      </BackendStatusChecker>
    </ToastProvider>
  );
};

export default AppWrapper;
